import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AdminLayout from '../templates/AdminLayout';
import StatCard from '../molecules/StatCard';
import SearchBar from '../molecules/SearchBar';
import AppButton from '../atoms/AppButton';
import OrdersKanban from '../organisms/OrdersKanban';
import { IconColumns, IconCheckCircle, IconDollarSign, IconPlus } from '../atoms/Icon';
import { formatBRL } from '../utils/currency';

function OrdersPage() {
  const [search, setSearch] = useState('');
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();
  const statsLoading = !stats;

  const statCards = useMemo(() => ([
    {
      label: 'Pedidos em andamento',
      value: stats?.inProgress,
      icon: <IconColumns size={18} />,
      bg: 'var(--color-amber-ghost)',
      color: 'var(--color-amber-primary)',
    },
    {
      label: 'Prontos',
      value: stats?.doneToday,
      icon: <IconCheckCircle size={18} />,
      bg: '#edfaf3',
      color: '#2a9d5c',
    },
    {
      label: 'Faturamento em aberto',
      value: stats ? formatBRL(stats.revenue) : null,
      icon: <IconDollarSign size={18} />,
    },
  ]), [stats]);

  return (
    <AdminLayout>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-4 flex-wrap">
        <h4 className="fw-semibold mb-0" style={{ color: 'var(--color-neutral)' }}>Pedidos</h4>
        <AppButton
          variant="primary"
          onClick={() => navigate('/pdv')}
          className="d-flex align-items-center gap-1"
        >
          <IconPlus size={15} /> Novo pedido
        </AppButton>
      </div>

      <Row className="g-3 mb-4 d-none d-md-flex">
        {statCards.map((stat) => (
          <Col key={stat.label} xs={12} sm={6} lg={4}>
            <StatCard {...stat} loading={statsLoading} />
          </Col>
        ))}
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={5} lg={4}>
          <SearchBar
            placeholder="Buscar por cliente ou nº do pedido..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search.trim() && (
            <div style={{ fontSize: 12, color: '#aaa', marginTop: 6 }}>
              Filtrando resultados — arraste desabilitado durante a busca.
            </div>
          )}
        </Col>
      </Row>

      <OrdersKanban search={search} onStatsChange={setStats} />
    </AdminLayout>
  );
}

export default OrdersPage;
